import React from 'react';

import BackgroundContainer, {
	BackgroundContainerProps as IBgProps,
} from 'pods/theme/components/BackgroundContainer';

import * as S from './Card.style';

interface IProps extends IBgProps {
	noPadding?: boolean;
	hover?: boolean;
	withShadow?: boolean;
	noBorder?: boolean;
	margin?: string;
	/** Allow the content overflow the card container, e.g. dropdown selection */
	allowOverflow?: boolean;
	allowChildrenEscape?: boolean;
	children: React.ReactNode;
}

const Card = ({
	noPadding = false,
	withShadow = false,
	noBorder = false,
	hover = false,
	allowOverflow = false,
	allowChildrenEscape = false,
	margin,
	children,
	...bgProps
}: IProps) => (
	<S.Wrapper>
		<S.Card
			className="core-component--card"
			{...{ withShadow, noBorder, hover, allowOverflow, margin }}
		>
			<BackgroundContainer
				isDefaultModule
				allowChildrenEscape={allowChildrenEscape}
				{...bgProps}
			>
				<S.Content {...{ noPadding }}>{children}</S.Content>
			</BackgroundContainer>
		</S.Card>
	</S.Wrapper>
);

export default Card;
